module.exports = __webpack_public_path__ + "img/no-data.419172f0.png";